var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var React = __importStar(require("react"));
var Link_1 = __importDefault(require("@material-ui/core/Link"));
var clsx_1 = __importDefault(require("clsx"));
var Link_styles_1 = require("./Link.styles");
/**
 * For more advanced usages, check [Material UI Link docs](https://material-ui.com/components/links/)
 *
 * ## Importing
 *
 * ```
 * import { Link } from '@naturacosmeticos/natds-web';
 * ```
 *
 * @see https://material-ui.com/components/links/
 */
exports.Link = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, _a = props.color, color = _a === void 0 ? 'default' : _a, style = props.style, otherProps = __rest(props, ["className", "children", "color", "style"]);
    var stylesForDefault = (0, Link_styles_1.useStyles)({ children: children, color: color }).default;
    var getColorForMaterial = function () {
        if (color === 'default') {
            return 'inherit';
        }
        return color;
    };
    return (React.createElement(Link_1.default, __assign({ className: (0, clsx_1.default)(stylesForDefault, className), color: getColorForMaterial(), style: style, ref: ref }, otherProps), children));
});
exports.Link.displayName = 'Link';
exports.default = exports.Link;
//# sourceMappingURL=Link.js.map